<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="ticketInfoTable"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column :label="$t('alarmHistory.index')"
                       type="index"
                       width="50"></el-table-column>
      <!-- 货物类型 -->
      <el-table-column prop="goodsTypeName"
                       :label="this.$t('expressDelivery.goodsType')">
        <template slot-scope="scope">
          <span>{{scope.row.goodsTypeName | maybeEmpty}}</span>
        </template>
      </el-table-column>

      <!-- SN号 -->
      <el-table-column prop="snNo"
                       v-if="ticketTemplateCode !== 'CollectDelivery'"
                       :label="this.$t('equipment.snNumber')">
        <template slot-scope="scope">
          <span>{{scope.row.snNo | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 货物描述 -->
      <el-table-column prop="goodsDesc"
                       :label="this.$t('expressDelivery.goodsDesc')">
        <template slot-scope="scope">
          <span>{{scope.row.goodsDesc | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 数量-->
      <el-table-column prop="quantity"
      v-if="ticketTemplateCode == 'CollectDelivery'"
                       :label="$t('GeneralServices.count')">
        <template slot-scope="scope">
          <span>{{scope.row.quantity }}</span>
        </template>
      </el-table-column>

      <!-- 是否发送 -->
      <el-table-column prop="isSend "
                       v-if="ticketTemplateCode !== 'CollectDelivery'"
                       :label="this.$t('expressDelivery.isSend')">
        <template slot-scope="scope">
          <span>{{scope.row.isSend | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 快递单号 -->
      <el-table-column prop="courierCode "
                       v-if="ticketTemplateCode !== 'CollectDelivery'"
                       :label="this.$t('faultReport.courierCode')">
        <template slot-scope="scope">
          <span>{{scope.row.courierCode | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 描述 -->
      <el-table-column prop="courierDesc "
                       v-if="ticketTemplateCode !== 'CollectDelivery'"
                       :label="this.$t('expressDelivery.description')">
        <template slot-scope="scope">
          <span>{{scope.row.courierDesc | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 是否接收 -->
      <el-table-column prop="isReceived"
                       v-if="ticketTemplateCode === 'CollectDelivery'"
                       :label="this.$t('expressDelivery.isReceived')">
        <template slot-scope="scope">
          <span>{{scope.row.isReceived | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 存放位置 -->
      <el-table-column prop="storageLocation"
                       v-if="ticketTemplateCode === 'CollectDelivery'"
                       :label="this.$t('expressDelivery.storageLocation')">
        <template slot-scope="scope">
          <span>{{scope.row.storageLocation | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 存放描述 -->
      <el-table-column prop="storageDesc"
                       v-if="ticketTemplateCode === 'CollectDelivery'"
                       :label="this.$t('expressDelivery.storageDesc')">
        <template slot-scope="scope">
          <span>{{scope.row.storageDesc | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 附件 -->
      <el-table-column prop="packageAttach"
                       v-if="ticketTemplateCode === 'CollectDelivery'"
                       :label="this.$t('text.enclosure')">
        <template slot-scope="scope">
          <div v-if="scope.row.packageAttach && scope.row.packageAttach.length">
            <a v-for="attach in scope.row.packageAttach"
               :href="attach.attachPath"
               target="_self"
               class="auto-break"
               :title="$t('ticket.clickDownload')">{{attach.attachName}}</a><br />
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  cloneDeep
} from 'lodash';

export default {
  props: {
    // info
    ticketInfoTable: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    },
    ticketTemplateCode: {
      type: String,
      default: ''
    },
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
a.auto-break {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/PackageInfo.vue